import { schoolTokenAxios } from "app/services/axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;

let eswa_url = `${SCHOOL_BASE}/com/wa`;

export const getWhatsAppProvider = (payload) => {
  return schoolTokenAxios.get(`${eswa_url}/getWhatsAppProvider`, {
    params: payload,
  });
};

export const createWaCampaign = (payload) => {
  return schoolTokenAxios.post(`${eswa_url}/createWaCampaign`, payload);
};

export const getWhatsAppTemplates = (payload) => {
  return schoolTokenAxios.get(`${eswa_url}/getWhatsAppTemplates`, {
    params: payload,
  });
};

export const sendWhatsAppTemplate = (payload) => {
  return schoolTokenAxios.post(`${eswa_url}/sendWhatsAppTemplate`, payload);
};

// broadcastWhatsAppTemplateByCom
export const broadcastWhatsAppTemplateByCom = (payload) => {
  return schoolTokenAxios.post(
    `${eswa_url}/broadcastWhatsAppTemplateByCom`,
    payload
  );
};
